import { TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

/**
 * FormField component with label and text input
 *
 * @param {Object} props - Component props
 * @param {string} props.fieldLabel - Label text
 * @param {Object} textFieldProps - Props for TextField component
 * @returns {JSX.Element} Labeled form field
 */
function FormField({ fieldLabel, ...textFieldProps }) {
  return (
    <Grid display="flex" alignItems="center" justifyContent="space-between" width="100%">
      <Typography sx={{ width: "30%", fontSize: "1.1rem" }}>{fieldLabel}</Typography>
      <TextField fullWidth {...textFieldProps} />
    </Grid>
  );
}
export default FormField;
